import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getWashingMachinePartApi, updateWashingMachinePartApi } from '@/apis/washingMachinePart'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { SuccessResponse, WashingMachinePart } from '@/types'
import { GetWashingMachinePartRequest } from '@/types/apis/washingMachinePart/GetWashingMachinePartRequest'
import { UpdateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/UpdateWashingMachinePartRequest'

export const useUpdateWashingMachinePart = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<SuccessResponse>()

  const update = useCallback(
    async (request: UpdateWashingMachinePartRequest) => {
      try {
        setLoading(true)
        const res = await updateWashingMachinePartApi(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
        navigate(routes.washingMachinePart.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    updateWashingMachinePart: update,
    response,
  }
}

export const useGetWashingMachinePart = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<WashingMachinePart>()

  const get = useCallback(async (request: GetWashingMachinePartRequest) => {
    try {
      setLoading(true)
      const res = await getWashingMachinePartApi(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getWashingMachinePart: get,
    response,
  }
}
